import { render, staticRenderFns } from "./ChangeMediaModal.vue?vue&type=template&id=48cedc06&"
import script from "./ChangeMediaModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeMediaModal.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeMediaModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports